<script setup lang="ts">
type IProps = {
  isFirst?: boolean;
  isActive?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  value: string;
}

const props = withDefaults(defineProps<IProps>(), {
  isSuccess: false,
  isError: false,
  isActive: false,
  isFirst: false,
});

const classDefault = "text-[var(--m-neutral-900)] bg-[var(--m-neutral-100)]  border-[var(--m-neutral-300)]";
const classActive = " text-[var(--m-light)]       bg-[var(--m-primary-base)] border-[var(--m-primary-base)]";
const classError = "  text-[var(--m-red)]         bg-[#FFD8D8]               border-[var(--m-red)]"
const classSuccess = "text-[var(--m-light)]       bg-[var(--m-green)]        border-[var(--m-green)]"
const classes = props.isError
    ? classError
    : props.isSuccess
        ? classSuccess
        : props.isActive
            ? classActive
            : classDefault;

</script>

<template>
  <div v-if="!isFirst"
       class="flex-auto border-t-2 transition duration-500 ease-in-out border-[var(--m-neutral-300)]"></div>
  <div class="flex items-center relative">
    <div
        class="rounded-full transition duration-500 ease-in-out h-8 w-8 py-3 flex items-center justify-center border-[1px] font-bold text-[16px]"
        :class="classes"
    >
      <svg v-if="props.isSuccess" width="18" height="13" viewBox="0 0 18 13" fill="currentColor"
           xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.9997 10.1709L16.1921 0.978516L17.6063 2.39273L6.9997 12.9993L0.635742 6.6354L2.04996 5.2212L6.9997 10.1709Z"
            fill="currentColor"/>
      </svg>
      <span v-else>{{ props.value }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>